module.exports = __webpack_public_path__ + "Flag-430.c8deea28da76f0b29b8f1e6882496b31.svg";